import type { FormApiQuestionnaire } from 'form-api';

export const QuestionnaireSlug = {
  cq_rcpro_coa: 'cq_rcpro_coa',
  cq_rcpro_cobsp: 'cq_rcpro_cobsp',
  cq_rcpro_mia: 'cq_rcpro_mia',
  cq_rcpro_miobsp: 'cq_rcpro_miobsp',
  cq_gf_ias: 'cq_gf_ias',
  cq_gf_iobsp: 'cq_gf_iobsp',
  cq_honorabilite: 'cq_honorabilite',
  cq_capacite_pro_ias: 'cq_capacite_pro_ias',
  cq_formation_continue_ias: 'cq_formation_continue_ias',
  cq_capacite_pro_iobsp: 'cq_capacite_pro_iobsp',
  cq_formation_continue_iobsp: 'cq_formation_continue_iobsp',
  // Questionnaire d'axe « liste des assujettis » : catalogue de slugs valides
  // UNIQUEMENT (le slug est seedé et servi par form-api). Ne PAS l'ajouter aux
  // mappings axeTypeToQuestionnaireSlug / dimensionToQuestionnaireSlug (cf.
  // liste-assujettis.definition.ts : le chemin legacy émettrait un message).
  cq_assujetti_liste: 'cq_assujetti_liste',
} as const;

export type QuestionnaireSlug =
  (typeof QuestionnaireSlug)[keyof typeof QuestionnaireSlug];

export type OptionColor = FormApiQuestionnaire.OptionColor;
export type QuestionAnswerConfidence =
  FormApiQuestionnaire.QuestionAnswerConfidence;
export type QuestionAnswerAiSuggestion =
  FormApiQuestionnaire.QuestionAnswerAiSuggestion;
export type QuestionAnswerGuardrail =
  FormApiQuestionnaire.QuestionAnswerGuardrail;
export type QuestionType = FormApiQuestionnaire.QuestionType;
export type QuestionOption = FormApiQuestionnaire.QuestionOption;
export type QuestionOptionInput = FormApiQuestionnaire.QuestionOptionInput;
export type ConditionRule = FormApiQuestionnaire.ConditionRule;
export type ConditionRuleGroup = FormApiQuestionnaire.ConditionRuleGroup;
export type QuestionCondition = FormApiQuestionnaire.QuestionCondition;
export type QuestionnaireDefinitionResponse =
  FormApiQuestionnaire.QuestionnaireDefinitionResponse;
export type QuestionDefinitionResponse =
  FormApiQuestionnaire.QuestionDefinitionResponse;
export type QuestionnaireInstanceResponse =
  FormApiQuestionnaire.QuestionnaireInstanceResponse;
export type QuestionAnswerResponse =
  FormApiQuestionnaire.QuestionAnswerResponse;
export type CreateQuestionnaireDefinitionRequestType =
  FormApiQuestionnaire.CreateQuestionnaireDefinitionRequestType;
export type CreateQuestionDefinitionRequestType =
  FormApiQuestionnaire.CreateQuestionDefinitionRequestType;
export type UpdateQuestionnaireDefinitionRequestType =
  FormApiQuestionnaire.UpdateQuestionnaireDefinitionRequestType;
export type SaveQuestionnaireInstanceRequestType =
  FormApiQuestionnaire.SaveQuestionnaireInstanceRequestType;
export type GetLatestInstancesRequestType =
  FormApiQuestionnaire.GetLatestInstancesRequestType;
